// extracted by mini-css-extract-plugin
export default {"blur":"SkeletonSearchDesktop-module__blur____VmQA"};